const config = {
    OfferMessage: {
        title: 'Thank You',
        Description:
            'You have successfully signed up for offers. Your first offer will be arriving shortly.',
    },
    SubscriptionMessage: {
        heading: 'Be the first to know about the latest deals and more!',
        placeHolder: 'Phone Number or Email',
        signUpLabel: 'signup',
        title: '*Text Alerts:',
        subtitle: 'Message and data rates may apply.',
        details:
            'By providing my mobile number, I agree to receive autodialed promotional alerts from JCPenney to that number. I understand that consent is not required to purchase goods or services. Message frequency varies. Text *HELP to 527937 for help and STOP to 527937 to cancel.',
    },
    Privacy: [
        {
            key: 1,
            text: 'Privacy Notice',
            linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg4003700013',
            linkPathMobile: '/jsp/customerservice/serviceContent.jsp?pageId=pg4003700013',
        },
        {
            key: 2,
            text: 'Do Not Sell My Personal Information',
            linkPath: '',
            linkPathMobile: '',
        },
        {
            key: 3,
            text: 'CA Supply Chain Act',
            linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg40055300008',
            linkPathMobile: '/jsp/customerservice/serviceContent.jsp?pageId=pg40055300008',
        },
        {
            key: 4,
            text: 'CA Privacy Rights',
            linkPath: '/m/privacy-notice#_notice_to_ca_residents',
            linkPathMobile: '/m/privacy-notice#_notice_to_ca_residents',
        },
    ],
    TermsLegal: [
        {
            key: 6,
            text: 'Terms & Conditions',
            linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg4004600015',
            linkPathMobile: '/jsp/customerservice/serviceContent.jsp?pageId=pg4004600015',
        },
        {
            key: 7,
            text: 'AdChoices',
            linkPath: 'http://optout.aboutads.info/#!/',
            linkPathMobile: 'http://optout.aboutads.info/?c=2#!/',
        },
    ],
    FooterLinks: [
        {
            key: 1,
            text: 'My Account',
            data: [
                {
                    key: 1,
                    text: 'Track My Order',
                    linkPath: '/orders/trackorders',
                    linkPathMobile: '/orders/trackorders',
                },
                {
                    key: 2,
                    text: 'Pay Bill & Manage Account',
                    linkPath: 'https://www.jcpcreditcard.com/',
                    linkPathMobile: 'https://www.jcpcreditcard.com/',
                },
                {
                    key: 3,
                    text: 'My JCP.com Account',
                    linkPath: '/account/dashboard?fromEvent=fromCSFooterLink&pageId=pg4005500015',
                    linkPathMobile: '/account/dashboard',
                },
                {
                    key: 4,
                    text: 'Apply for JCP Credit Card',
                    linkPath:
                        'https://apply.syf.com/EApply/eapply.action?clientCode=JCPCON&preQual=Y&sitecode=CREDBNPQ22',
                    linkPathMobile:
                        'https://apply.syf.com/EApply/eapply.action?clientCode=JCPCON&preQual=Y&sitecode=CREDBNPQ22',
                },
                {
                    key: 5,
                    text: 'Credit Card Benefits',
                    linkPath: '/jsp/customerservice/plccBenefits.jsp',
                    linkPathMobile: 'https://www.jcpenney.com/jsp/customerservice/plccBenefits.jsp',
                },
                {
                    key: 6,
                    text: 'JCPenney Rewards',
                    linkPath: '/rewards',
                    linkPathMobile: '/rewards',
                },
            ],
        },
        {
            key: 2,
            text: 'Customer Service',
            data: [
                {
                    key: 1,
                    text: 'Contact Us',
                    linkPath: '/rewards',
                    linkPathMobile: '/rewards',
                },
                {
                    key: 2,
                    text: 'Return Policy',
                    linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg100026',
                    linkPathMobile: '/customerService/articles?pageId=returns',
                },
                {
                    key: 3,
                    text: 'Shipping Information',
                    linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg4005500014',
                    linkPathMobile: '/customerService/articles?pageId=shipping-info',
                },
                {
                    key: 4,
                    text: 'Rebates',
                    linkPath:
                        '/dotcom/jsp/customerservice/serviceContent.jsp?pageId=pg40036500008&lang=en&stop_mobi=yes',
                    linkPathMobile:
                        '/dotcom/jsp/customerservice/serviceContent.jsp?pageId=pg40036500008&lang=en&stop_mobi=yes',
                },
                {
                    key: 5,
                    text: 'Recalls',
                    linkPath: '/jsp/customerservice/serviceContent.jsp?pageId=pg40064800008',
                    linkPathMobile: '/jsp/customerservice/serviceContent.jsp?pageId=pg40064800008',
                },
                {
                    key: 6,
                    text: 'Gift Cards',
                    linkPath:
                        '/jsp/browse/marketing/promotion.jsp?pageId=pg40053400007&cm_re=S1-_-M2-_-GIFTCARDS_DESKTOP',
                    linkPathMobile:
                        '/jsp/browse/marketing/promotion.jsp?pageId=pg40053400007&cm_re=PROMO-M2-MW-_-HP-_-mwtsgiftcards',
                },
                {
                    key: 7,
                    text: 'Servicio Al Cliente',
                    linkPath: '/jsp/customerservice/customerService.jsp?pageId=pg100087',
                    linkPathMobile: '',
                },
                {
                    key: 8,
                    text: 'Accessible view',
                    linkPath: 'http://assistive.jcpenney.com/h5/access/index',
                    linkPathMobile: 'http://assistive.jcpenney.com/h5/access/index',
                },
            ],
        },
        {
            key: 3,
            text: 'Stores',
            data: [
                {
                    key: 1,
                    text: 'Weekly Ad',
                    linkPath: '/jsp/browse/marketing/promotion.jsp?pageId=pg40030000010',
                    linkPathMobile:
                        'http://storeads.jcpenney.com/h/m/jcpenney?auto_locate=true&auto_store=true&hide=distribution&locale=en-US&type=1',
                },
                {
                    key: 2,
                    text: 'JCP Salon',
                    linkPath: '/g/salon/N-1b2lw2f?',
                    linkPathMobile: '/g/salon/N-1b2lw2f?',
                },
                {
                    key: 4,
                    text: 'Portraits',
                    linkPath: 'http://www.jcpportraits.com/',
                    linkPathMobile: 'http://www.jcpportraits.com/',
                },
                {
                    key: 5,
                    text: 'Optical',
                    linkPath: 'http://www.jcpenneyoptical.com/',
                    linkPathMobile: 'http://www.jcpenneyoptical.com/',
                },
                {
                    key: 6,
                    text: 'JCP Custom Window',
                    linkPath: '/jsp/browse/marketing/promotion.jsp?pageId=pg40064400006',
                    linkPathMobile: '/jsp/browse/marketing/promotion.jsp?pageId=pg40064400006',
                },
                {
                    key: 7,
                    text: 'Kids Zone',
                    linkPath: '/jsp/browse/marketing/promotion.jsp?pageId=pg40069600006',
                    linkPathMobile: '/jsp/browse/marketing/promotion.jsp?pageId=pg40069600006',
                },
            ],
        },
        {
            key: 4,
            text: 'About Us',
            data: [
                {
                    key: 1,
                    text: 'Careers',
                    linkPath: 'http://jobs.jcp.com/',
                    linkPathMobile: 'http://jobs.jcp.com/',
                },
                {
                    key: 2,
                    text: 'Company Info',
                    linkPath: '/jsp/browse/marketing/promotion.jsp?&pageId=pg40036000011',
                    linkPathMobile: '/jsp/browse/marketing/promotion.jsp?&pageId=pg40036000011',
                },
                {
                    key: 3,
                    text: 'Community',
                    linkPath: '/jsp/browse/marketing/promotion.jsp?pageId=pg40013300014',
                    linkPathMobile: '/jsp/browse/marketing/promotion.jsp?pageId=pg40013300014',
                },
                {
                    key: 4,
                    text: 'Media',
                    linkPath: 'http://www.jcpnewsroom.com/',
                    linkPathMobile: 'http://www.jcpnewsroom.com/',
                },
                {
                    key: 5,
                    text: 'Investors',
                    linkPath: 'http://ir.jcpenney.com/phoenix.zhtml?c=70528&p=irol-irHome',
                    linkPathMobile: 'http://ir.jcpenney.com/phoenix.zhtml?c=70528&p=irol-irHome',
                },
                {
                    key: 6,
                    text: 'Style by JCPenney',
                    linkPath: 'http://ir.jcpenney.com/phoenix.zhtml?c=70528&p=irol-irHome',
                    linkPathMobile: 'http://ir.jcpenney.com/phoenix.zhtml?c=70528&p=irol-irHome',
                },
            ],
        },
    ],
    ConnectWithUs: [
        {
            key: 1,
            text: 'Facebook',
            iconName: 'socialmedia-facebook',
            linkPath: 'https://www.facebook.com/jcp',
            linkPathMobile: 'https://www.facebook.com/jcp',
        },
        {
            key: 2,
            text: 'Twitter',
            iconName: 'socialmedia-twitter',
            linkPath: 'https://twitter.com/jcpenney',
            linkPathMobile: 'https://twitter.com/jcpenney',
        },
        {
            key: 3,
            text: 'Pinterest',
            iconName: 'socialmedia-pinterest',
            linkPath: 'https://www.pinterest.com/jcpenney/',
            linkPathMobile: 'https://www.pinterest.com/jcpenney/',
        },
        {
            key: 4,
            text: 'Instagram',
            iconName: 'instagram-line',
            linkPath: 'https://www.instagram.com/jcpenney',
            linkPathMobile: 'https://www.instagram.com/jcpenney',
        },
        {
            key: 5,
            text: 'Youtube',
            iconName: 'socialmedia-youtube',
            linkPath: 'https://www.youtube.com/jcpenney',
            linkPathMobile: 'https://www.youtube.com/jcpenney',
        },
        {
            key: 6,
            text: 'JCPenney Blog',
            iconName: 'socialmedia-blog',
            linkPath: '/penneypointers',
            linkPathMobile: '/penneypointers',
        },
    ],
    DownloadApp: {
        title: 'Download Our App',
        subtitle: 'Get your rewards & coupons all in one place',
        ctaLabel: 'Check Out Our Apps',
        ctaUrl: '/m/jcp-app?pageId=pg40046700014',
        label: 'Download JCPenney App',
    },
    MediaNote: 'Penney IP LLC',
    AdChoiceImg: 'assets/img/adchoice.png',
    SubscriptionLabels: {
        done: 'Done',
        privacyNotice: ' Privacy Notice',
        termsAndConditions: ' Terms & Conditions.',
        textAlerts: '*Text Alerts: ',
        signUpMessage: 'Be the first to know about the latest deals and more!',
        signUpButton: 'Sign Up',
        alertMessage: 'Message and data rates may apply.',
        seeDetails: 'See Details',
        seeDetailsMore:
            '*Text Alerts: Message and data rates may apply. By providing my mobile number, I agree to receive autodialed promotional alerts from JCPenney to that number. I understand that consent is not required to purchase goods or services. Message frequency varies. Text HELP to 527937 for help and STOP to 527937 to cancel.',
        seeDetailsLink: '/m/legal#terms%20of%20sms',
    },
    PlayStoreUrls: {
        androidLink: 'https://smart.link/5d814e19932cf?site_id=footer',
        iOSLink: 'https://smart.link/5d814e8cacf38?site_id=footer',
    },
    Validations: {
        errorMessage: "Oops. We couldn't process this request. Please try again.",
        emailRegex: /(.+)@(.+){2,}\.(.+){2,}/,
        phoneRegex: /^\d{3}-\d{3}-\d{4}$/,
        formatPhoneRegex: /(\d{3})(\d{3})(\d{4})/,
        emptyErrorMessage: 'Enter phone number or Email',
        invalidErrorMessage: 'Please enter a valid phone number or Email',
        mobilePlaceHolder: 'Phone Number or Email',
        desktopPlaceHolder: 'Phone Number or Email',
    },
    AdChoices: 'Ad Choices',
};

export default config;
